<template>
    <div class="legal-person-result" v-loading="pageLoading">
        <div v-if="status == 1" class="sr-result success">
            <span class="icon"></span>
            <div class="content">
                <h5>企业认证成功</h5>
                <p>
                    1. 该账号
                    <b>已经升级为企业账号</b>
                    <br />
                    2. 接下来，您需要签署企业合同才可以进行发行
                </p>
                <div class="btns">
                    <el-button @click="$router.push({path: `/manage/dashboard`})">暂不签署</el-button>
                    <el-button type="primary" @click="$contractRouter('/manage/contract/enterprise/fdd/signContract')">签署合同</el-button>
                </div>
            </div>
        </div>
        <div v-else-if="status == -1" class="sr-result error">
            <span class="icon"></span>
            <div class="content">
                <h5>企业认证失败</h5>
                <p>
                    失败原因：{{ errorMessage }}
                    <br />
                    如有疑问请
                    <span class="important">联系客服</span>
                </p>
                <el-button v-if="status == -1" @click="restartCertification()" type="primary">重新认证</el-button>
            </div>
        </div>
        <div v-else class="sr-result progress">
            <span class="icon"></span>
            <div class="content">
                <h5>企业认证进行中</h5>
                <p>
                    <b>委托书审核通过后，即可完成企业认证。</b>
                    <br />
                    委托书审核通过后将短信通知您；
                    <br />
                    预计将在（提交委托书时间+20分钟）内完成审核；
                    <br />
                    人工审核有一定延迟，请耐心等候。
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import {enterpriseRestart} from '@/api/user';
export default {
    data() {
        return {
            errorMessage: '',
            status: null, // -1 认证失败  0 认证进行中 1 认证成功
            pageLoading: false,
        };
    },
    mounted() {
        this.getStatus();
    },
    methods: {
        // 重新认证
        async restartCertification() {
            const respnose = await enterpriseRestart();
            const {state, msg} = respnose.data;
            if (!state) return this.$message.error(msg || '重新认证失败，请稍后尝试');
            await this.$store.dispatch('getEnterpriseCertify', true);
            this.$contractRouter('/manage/contract/enterprise/fdd');
        },
        async getStatus() {
            this.pageLoading = true;
            const result = await this.$store.dispatch('getEnterpriseCertify', true);
            this.pageLoading = false;
            if (result) {
                this.errorMessage = result.upgradeFailMsg;
                this.status = result.upgradeStatus;
                if (result.upgradeStatus == 1) {
                    // 更新用户信息
                    await this.$store.dispatch('getUserInfo');
                }
            }
            if (result.upgradeStatus == 0) {
                await new Promise((resolve) => setTimeout(resolve, 5000));
                this.getStatus();
            }
        },
    },
};
</script>

<style lang="scss"></style>
